import type { SellCountry } from "./config";

/**
 * Formaterar pris i rätt valuta efter annonsens land: 1 234 kr respektive
 * 1.234 € (spansk konvention). Används överallt priser visas.
 */
export function formatPrice(amount: number, country: SellCountry): string {
  try {
    const locale = country === "ES" ? "es-ES" : "sv-SE";
    const formatted = new Intl.NumberFormat(locale, {
      maximumFractionDigits: 0,
    }).format(amount);
    return country === "ES" ? `${formatted} €` : `${formatted} kr`;
  } catch {
    return `${amount} ${country === "ES" ? "€" : "kr"}`;
  }
}

/** Språk- och landanpassad kort datum: 15 sep 2026 / 15 Sep 2026 / 15 sep 2026. */
export function formatDate(
  date: string | Date,
  lang: string,
  country: SellCountry,
): string {
  const d = typeof date === "string" ? new Date(date) : date;
  try {
    const locale = lang === "en" ? (country === "ES" ? "en-IE" : "en-GB") : lang === "es" ? "es-ES" : "sv-SE";
    return new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(d);
  } catch {
    return d.toISOString().slice(0, 10);
  }
}

/** "för 2 h sedan" / "hace 2 h" / "2 h ago". */
export function formatRelativeTime(
  date: string | Date,
  lang: string,
): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const diff = Math.max(0, Date.now() - d.getTime());
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: "auto" });
  const mins = Math.round(diff / 60000);
  if (mins < 60) return rtf.format(-mins, "minute");
  const hours = Math.round(mins / 60);
  if (hours < 24) return rtf.format(-hours, "hour");
  const days = Math.round(hours / 24);
  if (days < 30) return rtf.format(-days, "day");
  const months = Math.round(days / 30);
  if (months < 12) return rtf.format(-months, "month");
  return rtf.format(-Math.round(months / 12), "year");
}
